'use client';

import React from 'react';
import styles from './index.module.css';
import BgRoleDetail from './images/bg-role-detail.png';
import WblLogo from './images/wbl-logo.png';
import Banner from './images/banner.png';
import GameJx3 from './images/game-jx3.png';
import GameJx3Yq from './images/game-jx3yq.png';
import CopyRightButtonI from './images/copyright-button-i.png';
import CopyRightButtonA from './images/copyright-button-a.png';

const MobileIndex = () => {
  const [toggle, setToggle] = React.useState(false);
  React.useEffect(() => {
    /**
     * 转成rem
     * 750px基准
     */
    const calcWidth =
      document.documentElement.clientWidth < 375
        ? document.documentElement.clientWidth
        : 375;
    document.documentElement.style.fontSize = `${(calcWidth / 750) * 100}px`;
    // document.documentElement.style.width = '100%';
    // document.documentElement.style.height = '100%';
  }, []);
  return (
    <div
      style={{
        background: `url(${BgRoleDetail.src}) no-repeat`,
        backgroundSize: 'cover'
      }}
      className={styles.container}
    >
      <img
        src={`${WblLogo.src}`}
        style={{
          display: 'block',
          width: '2.51rem',
          // height: '0.72rem',
          margin: '0.48rem auto 0.24rem auto',
          // paddingTop: '0.48rem',
        }}
      />
      <div className={styles.mh32} style={{ marginBottom: '0.8rem' }}>
        <img style={{width: '100%'}} src={`${Banner.src}`} />
      </div>
      <div className={styles.title}>
        请选择常玩游戏
      </div>
      <div className={styles.gameContainer}>
        <a href="//m.seasunwbl.com/jx3/buyer.html">
          <img src={GameJx3.src} />
        </a>
        <a href="//m.seasunwbl.com/jx3yq/buyer.html">
          <img src={GameJx3Yq.src} />
        </a>
      </div>
      {!toggle ? (
        <img
          className={`${styles.copyRightButton} ${styles.inActiveButton}`}
          src={`${CopyRightButtonI.src}`}
          onClick={() => setToggle(true)}
        />
      ) : (
        <div
          className={`${styles.footerContainer} ${toggle && styles.toggleFooter}`}
        >
          <a href="//jx3.seasunwbl.com/protocol" style={{display: 'flex', alignItems: 'center', height: '0.3rem', marginBottom: '0.16rem'}}>
            万宝楼交易平台服务协议
          </a>
          <a href="//beian.miit.gov.cn" style={{display: 'flex', alignItems: 'center', height: '0.3rem', marginBottom: '0.16rem'}}>琼ICP备2021004338号-3</a>
          <a href="//jx3.seasunwbl.com/license" style={{display: 'flex', alignItems: 'center', height: '0.3rem', marginBottom: '0.16rem'}}>
            增值电信业务经营许可证
          </a>
          <div className="textContainer30">
            Copyright © 2012-{new Date().getFullYear()}
            海南西山居互动娱乐科技有限公司
          </div>
          <img
            src={`${CopyRightButtonA.src}`}
            className={`${styles.copyRightButton} ${styles.activeButton}`}
            onClick={() => setToggle(false)}
          />
        </div>
      )}
    </div>
  )
}

export default  MobileIndex;
